import React, { useContext, useEffect, useState } from 'react'
import { ClientContext } from '../../../contexts/clientProvider'
import Moviments from '../Moviments'
import BaseSelect from '../../General/FormsComp/Select/BaseSelect'
import BaseButton from '../../General/FormsComp/Button/BaseButton'

const Historico = () => {
    const { verifyMovimentsByMonth, setAlert } = useContext(ClientContext)
    const [month, setMonth] = useState((new Date().getMonth() + 1).toString())
    const [ano, setAno] = useState(new Date().getFullYear())
    const [allMoviments, setAllMoviments] = useState(null)
    const [open, setOpen] = useState(false)

    const monthOptions = [
        { id: '1', nome: 'Janeiro' },
        { id: '2', nome: 'Fevereiro' },
        { id: '3', nome: 'Março' },
        { id: '4', nome: 'Abril' },
        { id: '5', nome: 'Maio' },
        { id: '6', nome: 'Junho' },
        { id: '7', nome: 'Julho' },
        { id: '8', nome: 'Agosto' },
        { id: '9', nome: 'Setembro' },
        { id: '10', nome: 'Outubro' },
        { id: '11', nome: 'Novembro' },
        { id: '12', nome: 'Dezembro' }
    ]

    const yearOptions = Array.from({ length: 10 }, (_, i) => ({
        id: (ano - i).toString(),
        nome: (ano - i).toString()
    }))

    const handleOpenMoviments = async () => {
        const pad = (m) => Number(m) < 10 ? `0${m}` : `${m}`
        if (!month) return setAlert({ visible: true, title: 'Atenção!', placeholder: 'Selecione um mês', confirm: false, type: 'warning' })
        const ref = `${pad(month)}/${ano}`
        const dados = await verifyMovimentsByMonth(ref)
        if (!dados) return setAlert({ visible: true, title: 'Atenção!', placeholder: 'Nenhum movimento encontrado', confirm: false, type: 'warning' })
        setAllMoviments(dados)
        setOpen(true)
    }

    return (
        <div className='w-full min-h-full'>
            {open && (
                <Moviments closeModal={() => setOpen(false)} month={month} ano={ano} data={allMoviments} />
            )}

            <div className='flex justify-center items-center w-full mb-8'>
                <div className='bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 max-w-2xl w-full'>
                    <div className='flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-6'>
                        <div className='flex flex-col items-center space-y-2 min-w-[120px]'>
                            <BaseSelect
                                label='Selecione o mês'
                                name='month'
                                value={month}
                                onChange={(e) => setMonth(e.target.value)}
                                options={monthOptions}
                                placeholder='Selecione o mês'
                                valueKey='id'
                                labelKey='nome'
                                required
                            />
                        </div>
                        <div className='flex flex-col items-center space-y-2 min-w-[120px]'>
                            <BaseSelect
                                label='Selecione o ano'
                                name='year'
                                value={ano.toString()}
                                onChange={(e) => setAno(e.target.value)}
                                options={yearOptions}
                                placeholder='Selecione o ano'
                                valueKey='id'
                                labelKey='nome'
                                required
                            />
                        </div>
                        <div className='flex flex-col items-center'>
                            <BaseButton
                                onClick={handleOpenMoviments}
                                variant='primary'
                                size='md'
                                className='mt-6'
                            >
                                Verificar Movimentos do Mês
                            </BaseButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Historico


